export default __webpack_public_path__ + "static/media/6.80a2d6ba.png";